import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { Meta,Title } from '@angular/platform-browser';
enum FAQTab {
  myAccount = 0,
  aboutFamily = 1,
  calendar =2,
familyFaq =3,
familyPhotos=4,
emergency=5,
gps=6,
vault=7,
legacyVideo=8,
miscellaneous=9,
whoCanC=10,
navigateAccount=11
}

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    standalone: false
})
export class FaqComponent implements OnInit {

  @ViewChild('pricing') pricing;
  FAQType: any;
  currentFAQType: any;
  showFAQDetails: boolean = false;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private meta:Meta,
    private title:Title
  ) {
    this.title.setTitle("FAQs | Family Central");
    this.meta.addTag({ name: 'description', content: 'Find answers to Frequently Asked Questions about Family Central.' });
    this.FAQType = FAQTab;
    this.currentFAQType = this.FAQType.myAccount;
  }

  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }

  expand(event) {
    if (event.style.display === "block") {
      event.style.display = "none";
    } else {
      event.style.display = "block";
    }
  }
}
